import styled from '@emotion/styled';
import { forwardRef } from 'react';

import { animationFade } from '../../theme/animations/animationFade';
import { animationScaleFade2 } from '../../theme/animations/animationScaleFade';
import { cssUtil } from '../../theme/cssUtil';
import { su } from '../../theme/functions/su';
import { motion } from '../../theme/motion';

export function MoodGrid() {}

MoodGrid.Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const MoodGridItemBase = styled.div`
  flex: 0 0 auto;
  padding-inline-end: ${su(1.5)};
  padding-bottom: ${su(1.5)};

  &:not([data-animated='true']) {
    opacity: 0;
    animation-name: ${animationScaleFade2.in};
    animation-timing-function: ease-in-out;
    animation-duration: ${motion.duration.slow};
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    animation-delay: var(--animation-delay);

    ${cssUtil.isReducedMotion} {
      opacity: 1;
      animation-name: ${animationFade.in};
      animation-delay: initial;
    }
  }
`;

function handleMoodGridItemAnimationEnd(event) {
  event.currentTarget.setAttribute('data-animated', 'true');
}

MoodGrid.Item = forwardRef(function MoodGridItem(
  { onAnimationEnd = handleMoodGridItemAnimationEnd, ...props },
  ref,
) {
  return <MoodGridItemBase ref={ref} onAnimationEnd={onAnimationEnd} {...props} />;
});
